import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// Apis
import { PatentApiServiceImpl } from './apis/impls/patent-api-impl';
import { PatentApi } from './apis/patent-api';

export const patentModule = new ContainerModule((bind: interfaces.Bind) => {
    // Bind APIs
    bind(PatentApi).to(PatentApiServiceImpl);
});

// Export types and interfaces
export * from './types';
export * from './apis/patent-api';
